import { Upload } from 'lucide-react-native';
import { Pressable, StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { colors, radii, spacing } from '@/constants/theme';

export type UploadPickBoxProps = {
  /** "Upload content", or the server's "Add another video" once there are videos. */
  title: string;
  onPress: () => void;
  disabled?: boolean;
  testID?: string;
};

const TILE = 48;

/** The upload step's dashed "Upload content / From your camera roll" box (Figma "Choose content"). */
export function UploadPickBox({ title, onPress, disabled, testID }: UploadPickBoxProps) {
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel={`${title}, from your camera roll`}
      accessibilityState={{ disabled: !!disabled }}
      style={({ pressed }) => [styles.box, disabled && styles.disabled, pressed && styles.pressed]}
      testID={testID}
    >
      <View style={styles.tile}>
        <Upload size={24} color={colors.deepGreen} strokeWidth={2} />
      </View>
      <Text variant="bodyBold" color="deepGreen" align="center">
        {title}
      </Text>
      <Text variant="caption" color="textMuted" align="center">
        From your camera roll
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  box: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.lg,
    borderRadius: radii.lg,
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: colors.trackMutedFill,
    backgroundColor: colors.surface,
  },
  tile: {
    width: TILE,
    height: TILE,
    marginBottom: spacing.xs,
    borderRadius: radii.base,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.surfaceSunken,
  },
  disabled: { opacity: 0.5 },
  pressed: { opacity: 0.7 },
});
